module.exports = __webpack_public_path__ + "img/be6ae50.png";